import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard as Auth0Guard } from '@auth0/auth0-angular';
import { redirectToRightPlan } from '@sympheny/user/guards';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'projects',
    pathMatch: 'full',
  },
  {
    path: '',
    data: { breadcrumb: { skip: true } },
    loadChildren: () =>
      import('@sympheny/user/auth0').then((m) => m.UserAuth0Module),
  },
  {
    path: '',
    data: { breadcrumb: { skip: true } },
    loadChildren: () =>
      import('@sympheny/ui/error-pages').then((m) => m.routes),
  },
  {
    path: 'projects',
    loadChildren: () => import('./projects'),
    data: { breadcrumb: 'PROJECT.projects' },
    canActivate: [Auth0Guard, redirectToRightPlan()],
  },
  {
    path: 'projects',
    loadChildren: () => import('./project-details'),
    data: { breadcrumb: 'PROJECT.projects' },
    canActivate: [Auth0Guard, redirectToRightPlan()],
  },
  {
    path: 'dashboard',
    data: {
      breadcrumb: { skip: true },
    },
    loadChildren: () =>
      import('@sympheny/dashboard/result').then((r) => r.DashboardShareRoutes),
    canActivate: [Auth0Guard, redirectToRightPlan()],
  },
  {
    path: 'account',
    loadChildren: () => import('@sympheny/user/profile'),
    data: { breadcrumb: 'Profile' },
    canActivate: [Auth0Guard, redirectToRightPlan()],
  },
  {
    path: 'database',
    loadChildren: () => import('@sympheny/database/feature-edit'),
    data: { breadcrumb: 'DATABASE.database' },
    canActivate: [Auth0Guard, redirectToRightPlan()],
  },

  {
    path: 'ramp-mobility',
    loadChildren: () => import('@sympheny/ramp-mobility'),
    data: { breadcrumb: 'RAMP_MOBILITY.ramp-mobility' },
    canActivate: [Auth0Guard, redirectToRightPlan()],
  },

  {
    // Dev-only spartan/ui preview (flag `uiPreview`, off in prod). Deliberately NOT behind
    // Auth0Guard — it renders no user data and must be reachable logged-out for automated
    // visual checks.
    path: 'dev/ui',
    data: { breadcrumb: { skip: true } },
    loadChildren: () => import('./dev/routes'),
  },
  {
    path: '**',
    redirectTo: '404',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      enableTracing: false,
      // relativeLinkResolution: 'legacy',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
